module.exports = __webpack_public_path__ + "assets/3b0ea02bb02aa4ad635408f08f45e71c.png";